import { useState, useCallback } from 'react';
import type { NewDiscovery, EraUnlock, CollectionUnlock, Hint, TutorialState } from '../types';

export const useGameEvents = () => {
  const [newDiscovery, setNewDiscovery] = useState<NewDiscovery | null>(null);
  const [newEraUnlock, setNewEraUnlock] = useState<EraUnlock | null>(null);
  const [newCollectionUnlock, setNewCollectionUnlock] = useState<CollectionUnlock | null>(null);
  const [eraToAdvanceTo, setEraToAdvanceTo] = useState<EraUnlock | null>(null);
  const [unsuccessfulCombos, setUnsuccessfulCombos] = useState<number>(0);
  const [hint, setHint] = useState<Hint | null>(null);
  const [tutorialState, setTutorialState] = useState<TutorialState>({ active: null, step: 0 });

  const resetGameEvents = useCallback(() => {
    setNewDiscovery(null);
    setNewEraUnlock(null);
    setNewCollectionUnlock(null);
    setEraToAdvanceTo(null);
    setUnsuccessfulCombos(0);
    setHint(null);
    setTutorialState({ active: null, step: 0 });
  }, []);

  return {
    newDiscovery,
    setNewDiscovery,
    newEraUnlock,
    setNewEraUnlock,
    newCollectionUnlock,
    setNewCollectionUnlock,
    eraToAdvanceTo,
    setEraToAdvanceTo,
    unsuccessfulCombos,
    setUnsuccessfulCombos,
    hint,
    setHint,
    tutorialState,
    setTutorialState,
    resetGameEvents,
  };
};
